import { PropsWithChildren } from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import type { FilterSelectionKey } from './parameterFilters';

export type ParameterFilterFormValues = {
    filters: FilterSelectionKey[];
    positions: string[];
    selectedParameterIds: string[];
};

type ParameterFilterProviderProps = PropsWithChildren<{
    initialFilters?: FilterSelectionKey[];
    initialPositions?: string[];
    initialParameterIds?: string[];
}>;

/**
 * Provides parameter filter state to the parameter selection components.
 *
 * @param props Provider properties and child components.
 * @returns The parameter filter context provider.
 */
export const ParameterFilterProvider = ({
    initialFilters = [],
    initialPositions = [],
    initialParameterIds = [],
    children,
}: ParameterFilterProviderProps) => {
    const form = useForm<ParameterFilterFormValues>({
        defaultValues: {
            filters: initialFilters,
            positions: initialPositions,
            selectedParameterIds: initialParameterIds,
        },
    });

    return <FormProvider {...form}>{children}</FormProvider>;
};
